module.exports = __webpack_public_path__ + "images/smartphone-screen-2_f9ad1d27e8016dba03544ac5c25f4be7.png";